import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { Link } from "components/core/Link";
import { StarRating } from "../StarRating";

import "./StarReviewsCount.scss";

const StarReviewsCount = ({
	number,
	average,
	url = "",
	withLabel = false,
	className = "reviews-count",
	facilityCard = false
}) => (
	<div
		className={classnames(className, {
			"facility-card-reviews": facilityCard
		})}
	>
		<StarRating
			rating={average}
			outOf={5}
			withLabel={withLabel}
			className="star-reviews"
		/>
		<Link
			nowrap
			href={url}
			className="rating"
			hover
			size="small"
			weight="bold"
			color="lightGray"
		>
			{`(${number})`}
		</Link>
	</div>
);

StarReviewsCount.propTypes = {
	className: PropTypes.string,
	url: PropTypes.string,
	number: PropTypes.number,
	average: PropTypes.number,
	withLabel: PropTypes.bool,
	facilityCard: PropTypes.bool
};

export default StarReviewsCount;
